module.exports = __webpack_public_path__ + "img/horizontal_7_4_8011.f37b8460.png";